import { ButtonAppearances } from "../types";

export const mapButtonAppearance = (
    appearance: ButtonAppearances | "link"
): Exclude<ButtonAppearances, "destructive-tertiary"> | "link" => {
    let actualAppearance = appearance;

    // TODO delete this function and all usages in a major release.
    if (actualAppearance === "destructive-tertiary") {
        actualAppearance = "secondary-destructive";
    }
    return actualAppearance;
};
